import { TextField } from "@mui/material";
import InputMask from "react-input-mask";

export const CRP_FORMAT_REGEX = /^\d{2}\/\d{4,6}$/;

export const REGION_CODES = Array.from({ length: 24 }, (_, i) =>
  String(i + 1).padStart(2, "0")
);

interface CrpInputFieldProps {
  label: string;
  value: string;
  onChange: (v: string) => void;
  error?: boolean;
  helperText?: string;
  required?: boolean;
}

export function validateCpr(value: string): {
  isValid: boolean;
  message: string;
} {
  if (!value) return { isValid: true, message: "" };

  const isValidFormat = CRP_FORMAT_REGEX.test(value);
  if (!isValidFormat) {
    return {
      isValid: false,
      message:
        "O formato do CRP deve ser 'XX/XXXX', 'XX/XXXXX' ou 'XX/XXXXXX'.",
    };
  }

  const regionCode = value.substring(0, 2);
  if (!REGION_CODES.includes(regionCode)) {
    return { isValid: false, message: "Código de região do CRP inválido." };
  }

  return { isValid: true, message: "" };
}

export function CrpInputField({
  label,
  value,
  onChange,
  required = false,
}: CrpInputFieldProps) {
  const validation = validateCpr(value);
  const showHelperText = !validation.isValid && value.length > 0;
  const isError = !validation.isValid && value.length > 0;

  return (
    <InputMask
      mask="99/999999"
      maskChar={null}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      {
        ((inputProps: any) => (
          <TextField
            {...inputProps}
            fullWidth
            required={required}
            label={label}
            variant="outlined"
            error={isError}
            helperText={showHelperText ? validation.message : ""}
          />
        )) as unknown as React.ReactNode
      }
    </InputMask>
  );
}
